import {NgModule} from '@angular/core';
import {NebulaUtilsService} from '@scientifica-cms-fe/services/utils/utils.service';

@NgModule({
    providers: [
        NebulaUtilsService
    ]
})
export class NebulaUtilsModule {
    /**
     * Constructor
     */
    constructor(private _nebulaUtilsService: NebulaUtilsService) {
    }
}
